export default __webpack_public_path__ + "static/media/cover.d993e1c7.svg";